import makeApi from 'client/api'

const API_URL = process.env.REACT_APP_WEB_API || 'http://localhost:3030/api'

export const uploadPhoto = async (
  token: string,
  file: File,
  announcementId: string,
  index: number,
) => {
  let formData = new FormData()

  formData.append('image', file)
  return fetch(`${API_URL}/announcements/properties/${announcementId}/images?index=${index}`, {
    method: 'post',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  })
}

export const deletePhoto = (token: string, announcementId: string, photoId: string) => {
  const { delete: deleteApi } = makeApi({ token })
  return deleteApi(`/announcements/properties/${announcementId}/images`, { id: photoId })
}
